import React from 'react';
import classNames from 'classnames';
import { Redirect } from 'react-router-dom';
import { Nav, NavItem, NavLink } from 'reactstrap';
import PropTypes from 'prop-types';

import { AppSidebarToggler, AppNavbarBrand } from '@coreui/react';

import { SignOut } from 'aws-amplify-react-custom';
//import sygnet from '../../assets/img/brand/sygnet.svg';
let logo = null;
if (process.env.REACT_APP_LOGO !== 'none') {
 logo = require(`../../assets/${process.env.REACT_APP_CUSTOMER || "dualtron"}/img/brand/${process.env.REACT_APP_LOGO || "logo.svg"}`);
}
const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class SidebarToggler extends AppSidebarToggler {
  render () {
    const { className, children, tag: Tag, ...attributes } = this.props;

    delete attributes.mobile
    delete attributes.display

    const classes = classNames(className, 'navbar-toggler');
    return (
      <Tag type="button" className={classes} {...attributes} onClick={(event)=>this.sidebarToggle(event)} data-sidebar-toggler>
        {children || <i className="fas fa-bars text-secondary"></i>}
      </Tag>
    );
  }
}


class DefaultHeader extends SignOut {

  logout = () => {
    this.signOut();
  }

  render() {

    // eslint-disable-next-line
    const { authState, children, ...attributes } = this.props;

    // If authState is signedOut, redirect back to homepage
    if (authState === 'signedOut') {
      return <Redirect to='/' />
    }

    return (
      <React.Fragment>
        <SidebarToggler className="d-lg-none" display="md" mobile />
          {
           logo ?
            <AppNavbarBrand
              full={{ src: logo, width: 140, alt: 'DTCROS Logo' }}
              minimized={{ src: logo, width: 140, alt: 'DTCROS Logo' }}
            /> : null
          }
        <SidebarToggler className="d-md-down-none" display="lg" />
        <Nav className="ml-auto mr-3" navbar>
          <NavItem>
            <NavLink href="#" onClick={this.logout}><i className="fa fa-lock"></i> Logout</NavLink>
          </NavItem>
        </Nav>
        {/*<AppAsideToggler className="d-md-down-none" />*/}
        {/*<AppAsideToggler className="d-lg-none" mobile />*/}
      </React.Fragment>
    );
  }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

export default DefaultHeader;
